import * as moment from "moment";

export const formatDate = (
  date: Date | moment.Moment | string | undefined,
  format = "YYYY-MM-DD",
) => {
  if (!!date || typeof date === "string") {
    if (moment.isMoment(date)) {
      return date.format(format);
    } else {
      return moment(date).format(format);
    }
  }
  return date;
};

export const formatDateTime = (
  date: Date | moment.Moment | string | undefined,
  format = "lll",
) => {
  if (!!date || typeof date === "string") {
    if (moment.isMoment(date)) {
      return date.format(format);
    } else {
      return moment(date).format(format);
    }
  }
  return date;
};
